import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
  ButtonModule,
  ImageModule,
  LinkModule
} from '@com-delta-idp/mnx-ui-kit';
import { OnboardingComponent } from './onboarding.component';

@NgModule({
  declarations: [OnboardingComponent],
  imports: [CommonModule, ButtonModule, LinkModule, ImageModule],
  exports: [OnboardingComponent]
})
export class OnboardingModule {}
